import { render, staticRenderFns } from "./StaffManualPaymentsList.vue?vue&type=template&id=641fc135"
import script from "./StaffManualPaymentsList.vue?vue&type=script&lang=js"
export * from "./StaffManualPaymentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports